
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
		import HistoryInfo from './log-info'

	@Component({
		name: 'systemlog',
		components:{
			HistoryInfo
		}
	})

	export default class role extends Vue {
		addOrUpdateVisible=false
		loading: boolean = false;
		menuList=[];
		searchForm={
			operation:'',
			userName:'',
			category:'',
			time:[]
		}
		dataList=[]
		infoVisible=false
		dataListSelections=[]
		pageIndex= 1;
		recverVisible=false;
		pageSize=10;
		totalPage= 0;
		bmxx=[]
		exportVisible=false
		pickerOptions= {
			shortcuts: [{
				text: '最近一周',
				onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				picker.$emit('pick', [start, end]);
			}
		}, {
		text: '最近一个月',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			picker.$emit('pick', [start, end]);
		}
	}, {
		text: '最近三个月',
				onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			picker.$emit('pick', [start, end]);
		}
	}]
	}
		created() {
			this.getDataList();
			this.getbmxx()
		}
		getDataList() {
			this.$request({
				url: '/bjba/systemLog/page',
				method: 'get',
				params: {
					'page': this.pageIndex,
					'pageSize': this.pageSize,
					'userName': this.searchForm.userName,
					'category': this.searchForm.category,
					'startTime':this.searchForm.time? this.searchForm.time[0] : '',
					'endTime':this.searchForm.time? this.searchForm.time[1] :'',
					'operation': this.searchForm.operation
				}
			}).then(response => {
				console.log('aaaaaaaaaaaaaa'+response)
				this.dataList = response.data.data.content;
				this.totalPage = response.data.data.totalElements;
			}).catch(error => {
						console.log(error)
					});
		}

		changeIndex() {
			this.pageIndex = 1
		}

		// 每页数
		sizeChangeHandle (val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		}
		// 当前页
		currentChangeHandle (val) {
			this.pageIndex = val
			this.getDataList()
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		//info
		showInfo (id) {
			this.infoVisible = true
			this.$nextTick(() => {
				this.$refs.info.init(id)
			})
		}
		daochu(){
			console.log(this.searchForm.time)
			var startTime=this.searchForm.time.length==2? this.searchForm.time[0] : ''
			var endTime=this.searchForm.time.length==2? this.searchForm.time[1] :''
			console.log(startTime)
			console.log(endTime)
			var viewUrl = this.$request.defaults.baseURL+'/bjba/systemLog/export?userName='+this.searchForm.userName+'&category='+this.searchForm.category+'&startTime='+startTime+'&endTime='+endTime+'&access_token='+this.$store.getters.token
			window.open(viewUrl)
		}
		getbmxx() {
			let that = this;
			this.$request.get("/bjba/yhgl/getbmxx").then((res) => {
				console.log("bmxx:", res);
				that.bmxx = res.data;
			});
		}
		getBmxxForId(id){
			let that = this;
			var obj=that.bmxx.find(function (x) {
				return x.bmid === id
			})
			return obj.bmmc;
		}


	}
